import React, { useEffect } from "react";
import { doc, onSnapshot } from "firebase/firestore";
import { Typography } from "@mui/material";

import { Board } from "./geometry/Board";
import { useApp } from "../contexts/app";
import { firestore } from "../server/firebase";
import { parseServerAction } from "../server/game";
import { PiecesRoster } from "./PiecesRoster";
import { GameFinished } from "./GameFinished";
import { actionData } from "../types/game";

export const GameInterface = () => {
  const {
    state: { game },
    executeServerAction,
  } = useApp();

  // Ask for confirmation before leaving
  useEffect(() => {
    const hasLocalPlayerId = () =>
      game.localPlayerId !== null && game.localPlayerId !== undefined;

    window.addEventListener("beforeunload", function (e) {
      const msg: string = "You are about to quit the game";
      if (e) {
        e.returnValue = msg;
      }
      return msg;
    });

    // if game is online, add listener for moves from the other player
    if (game.onlineGameId && hasLocalPlayerId()) {
      console.log("adding listener for moves from the other player");
      console.log("listening for game", game.onlineGameId);
      return onSnapshot(
        doc(firestore, "onGoingGames", game.onlineGameId),
        (doc) => {
          const d = doc.data() as actionData | {};
          console.log("turn of player:", game.localPlayerId);
          console.log("local player id:", game.localPlayerId);

          console.log("detected move:", d);

          if (!!d && "type" in d && d.byPlayer !== game.localPlayerId) {
            const moveData = parseServerAction(d, game.players);
            // Check move has not already been made
            if (
              (moveData.type === "place" && game.board.isFree(moveData.hex)) ||
              (moveData.type === "move" &&
                game.board.pieces.some(
                  (p) => p.valueOf() === moveData.piece.valueOf()
                ))
            ) {
              executeServerAction(moveData);
            }
          }
        }
      );
    }
  }, [
    executeServerAction,
    game.board,
    game.localPlayerId,
    game.onlineGameId,
    game.players,
  ]);

  const queenNotYetPlaced = game.turnOfPlayer.piecesRoster.queen === 1;

  const getTurnPromptContent = () => {
    if (game.onlineGameId) {
      return game.turnOfPlayer.id === game.localPlayerId
        ? "Your turn"
        : `Waiting for ${
            game.turnOfPlayer.id === 0 ? "White" : "Black"
          }'s move`;
    } else {
      return `${game.turnOfPlayer.name} playing`;
    }
  };

  // TODO: change to game history empty
  // const isFirstTurn =
  //   game.turn === 0 && game.turnOfPlayer.id === 0 && game.action.placing;

  return (
    <div className="border fullheight">
      <div className="d-flex justify-content-between align-items-center">
        <Typography variant="h6">{getTurnPromptContent()}</Typography>
        {queenNotYetPlaced && game.turn <= 3 && (
          <Typography
            className="flex-wrap"
            variant="caption"
            align="right"
            style={{ maxWidth: "50%" }}
          >
            You must place your queen bee before turn 5
          </Typography>
        )}
      </div>

      <div
        className="h-100 d-flex flex-landscape-row"
        style={{ flexDirection: "column" }}
      >
        <div className="flex-grow-1">
          <Board pieces={game.board.pieces} />
        </div>
        <div className="">
          <PiecesRoster />
        </div>
        {/* <div className="h-100 flex-grow-1 d-flex flex-column">
          <Board pieces={game.board.pieces} />
        </div>
        <PiecesRoster />*/}
      </div>

      <GameFinished />
    </div>
  );
};
